<template>
  <div v-show="balances.length > 0">
    <material-card
      icon="check"
      :color="$vuetify.theme.themes.light.primary"
      :title="$t('components.benefits_balances.benefit_balance')"
    >
      <v-container fluid>
        <v-row>
          <v-col
            cols="auto"
            class="note-text ma-2 mb-4 ml-4 mr-0 pr-0 text-left"
          >
            {{ $t("components.benefits_balances.benefit_record") }}
            <strong>{{ $helpers.formatDate($helpers.dateNow()) }}</strong>
          </v-col>
          <!-- <v-col cols="auto" class="px-0 pt-2">
            <v-tooltip
              :disabled="$vuetify.breakpoint.xsOnly"
              top
              v-model="showTooltip"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  class="ml-sm-4 ml-1 mt-1"
                >
                  mdi-help-circle-outline
                </v-icon>
              </template>
              <span v-if="isInternationalStudent">
                {{ $t("components.benefits_balances.tooltip.international") }}
              </span>
              <span v-else>
                {{ $t("components.benefits_balances.tooltip") }}
              </span>
            </v-tooltip>
          </v-col> -->
        </v-row>
        <v-row no-gutters class="search">
          <v-col cols="12" sm="6" md="3" class="pa-4 pl-6 pt-0">
            <v-autocomplete
              clearable
              @click.clear="balancesFilter = 'all'"
              :menu-props="{ contentClass: 'text-left' }"
              name="balances"
              outlined
              hide-details
              dense
              v-model="balancesFilter"
              :items="balanceVariants"
              item-text="text"
              item-value="filter"
              auto-select-first
            ></v-autocomplete>
          </v-col>
        </v-row>
        <benefit-balances-form
          :patients="patients"
          :planBenefits="benefits"
          @benefit-selected="setSelectedBenefit"
          @patient-selected="selectedPatient = $event"
        />
        <benefit-balances-table
          :loading="loading"
          :balances="balancesToShow"
          :planBenefits="benefits"
          :searchString="search"
          @row-selected="setClickedBenefit"
        />
        <!-- <v-row v-if="benefitsBalanceNote" class="subtitle mt-2">
      <v-col class="text-left">
        <span
          class="subtitle pt-6"
          v-html="
            $vuetify.lang.current === 'fr'
              ? benefitsBalancesNote.FR
              : benefitsBalancesNote.EN
          "
        ></span>
      </v-col>
    </v-row>
    <v-row v-else class="mt-2">
      <v-col class="text-left">
        <span class="subtitle pt-6">
          {{ $t("components.benefits_balances.footer_note1") }}
        </span>
        <span class="subtitle">
          <router-link to="/contact">
            {{ $t("components.claims_history.footer_contacts") }}
          </router-link>
        </span>
        <span class="subtitle pt-6">
          {{ $t("components.benefits_balances.footer_note2") }}
        </span>
      </v-col>
    </v-row> -->
      </v-container>
    </material-card>
    <error-handler :error="error"></error-handler>

    <v-snackbar v-model="snackbar" color="success" :timeout="3000">
      {{ successMessage }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import BenefitBalancesForm from "@/components/MemberView/BenefitBalance/BenefitBalancesForm.vue";
import BenefitBalancesTable from "@/components/MemberView/BenefitBalance/BenefitBalancesTable.vue";
import ErrorHandler from "@/components/ErrorHandler.vue";

export default {
  components: {
    BenefitBalancesForm,
    BenefitBalancesTable,
    ErrorHandler,
  },
  props: ["memberIdentity", "dependants"],
  data() {
    return {
      error: undefined,
      snackbar: false,
      successMessage: "",
      memberBalances: {},
      selectedPatient: { Balances: [] },
      balancesFilter: "all",
      selectedBenefit: {},
      sortedPatients: [],
      patients: [],
      showTooltip: false,
      loading: false,
      search: "",
      benefits: [],
      balances: [],
      balanceVariants: [
        {
          text: this.$t("globals.all"),
          filter: "all",
        },
        {
          text: this.$t("components.benefits_balances.used_balance"),
          filter: "used",
        },
        {
          text: this.$t("components.benefits_balances.unused_balances"),
          filter: "unused",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("common", [
      "planBenefits",
      "userProfile",
      "benefitsBalanceNote",
      "enableClaimsMessage",
      "isDemoMockPlan",
    ]),
    disabledClaimsMessage() {
      if (this.enableClaimsMessage) {
        return this.$vuetify.lang.current === "fr"
          ? this.enableClaimsMessage.Fr
          : this.enableClaimsMessage.En;
      }
      return "";
    },
    balancesToShow() {
      if (this.balancesFilter === "used") {
        return this.balances.filter((b) => b.Used > 0);
      } else if (this.balancesFilter === "unused") {
        return this.balances.filter((b) => b.Used === 0);
      } else return this.balances;
    },
    ungroupedBalances() {
      if (this.balancesToShow === null || this.balancesToShow === undefined) {
        return [];
      }
      return this.balancesToShow.filter((b) => !b.GroupEN);
    },
    groupedBalances() {
      let groupedBalances = [];
      if (this.balancesToShow === null || this.balancesToShow === undefined) {
        return [];
      }
      this.balancesToShow.filter((b) => {
        if (b.GroupEN) {
          if (groupedBalances[b.GroupEN]) {
            groupedBalances[b.GroupEN].push(b);
          } else {
            groupedBalances[b.GroupEN] = [b];
          }
          return true;
        }
      });
      return Object.values(groupedBalances);
    },
    isInternationalStudent() {
      const memberGroup =
        this.memberIdentity.CurrentMembershipStatus.MemberGroupIdentity.Current
          .Name;
      if (memberGroup.toLowerCase().includes("international")) return true;
      return false;
    },
  },
  watch: {
    selectedPatient: {
      handler(v) {
        if (v) {
          this.getPatientBalances();
        }
      },
      // immediate: true,
    },
  },
  mounted() {
    this.getPatients();
    this.selectedPatient = this.patients[0];
  },
  methods: {
    ...mapActions("claims", ["getMemberBenefitBalances"]),
    getPatients() {
      console.log(this.memberIdentity, this.dependants);
      if (this.dependants === null || this.dependants === undefined) {
        this.patients = [];
      } else {
        this.patients = this.dependants
          .map((o) => {
            return {
              Id: o.IdentityId,
              FirstName: o.FirstName,
              LastName: o.LastName,
              MiddleName: o.MiddleName,
              DateOfBirth: o.DateOfBirth,
            };
          })
          .sort((a, b) => {
            if (Date.parse(a.DateOfBirth) < Date.parse(b.DateOfBirth)) {
              return -1;
            } else if (
              Date.parse(a.DateOfBirth) === Date.parse(b.DateOfBirth)
            ) {
              return 0;
            } else {
              return 1;
            }
          });
      }
      this.patients.unshift({
        Id: this.memberIdentity.Id,
        FirstName: this.memberIdentity.CurrentMember.FirstName,
        LastName: this.memberIdentity.CurrentMember.LastName,
        MiddleName: this.memberIdentity.CurrentMember.MiddleName,
        DateOfBirth: this.memberIdentity.CurrentMember.DateOfBirth,
      });
    },
    setClickedBenefit(benefit) {
      if (benefit) {
        this.selectedBenefit = this.balances.find(
          (b) => b.LabelEn === benefit.LabelEn
        );
      }
    },
    setSelectedBenefit(benefit) {
      if (benefit && this.selectedPatient) {
        this.search = benefit.DisplayValue;
        this.selectedBenefit = this.balances.find(
          (b) => b.LabelEn === benefit.LabelEn
        );
      } else this.search = "";
    },

    async getPatientBalances() {
      try {
        this.loading = true;
        let isDependant = true;
        if (this.selectedPatient.Id === this.memberIdentity.Id) {
          isDependant = false;
        }
        const payload = {
          MemberId: this.memberIdentity.Id,
        };
        if (isDependant) {
          payload.DependantId = this.selectedPatient.Id;
        }
        const balances = (
          await this.getMemberBenefitBalances({
            payload: payload,
          })
        ).data.sort((a, b) =>
          a.LabelEn > b.LabelEn ? 1 : b.LabelEn > a.LabelEn ? -1 : 0
        );
        this.balances = balances;
        this.benefits = this.sortAndAddCategories(balances);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    sortAndAddCategories(benefits) {
      benefits.sort((a, b) =>
        a.Coverage > b.Coverage ? 1 : b.Coverage > a.Coverage ? -1 : 0
      );
      let benefitsWithHeadersMap = {};
      for (let benefit of benefits) {
        console.log(benefit);
        benefit.DisplayValue =
          this.$vuetify.lang.current === "fr"
            ? benefit.LabelFr
            : benefit.LabelEn;
        if (benefit.Coverage !== null && benefit.Coverage !== undefined) {
          let type = benefit.Coverage;
          if (benefit.Coverage.toLowerCase().includes("drug")) {
            type = "Drugs";
          }

          if (benefitsWithHeadersMap[type]) {
            benefitsWithHeadersMap[type].push(benefit);
          } else {
            benefitsWithHeadersMap[type] = [benefit];
          }
        }
      }
      Object.keys(benefitsWithHeadersMap).forEach((category) => {
        benefitsWithHeadersMap[category].sort((a, b) =>
          a.DisplayValue > b.DisplayValue
            ? 1
            : b.DisplayValue > a.DisplayValue
            ? -1
            : 0
        );
      });
      let benefitsWithHeaders = [];
      const coverages = Object.keys(benefitsWithHeadersMap).sort();
      for (let coverage of coverages) {
        benefitsWithHeaders.push({
          header: this.$t(`globals.${coverage.toLowerCase()}`) || coverage,
        });
        benefitsWithHeaders = [
          ...benefitsWithHeaders,
          ...benefitsWithHeadersMap[coverage],
        ];
      }
      return benefitsWithHeaders;
    },
  },
};
</script>
<style scoped>
@media screen and (max-width: 1263px) {
  .benefit-title {
    font-size: 14px;
    font-weight: 600;
  }
  .balances {
    position: absolute;
    top: 25px;
    left: 20px;
  }
}
@media only screen and (min-width: 1264px) {
  .benefit-title {
    font-size: 16px;
    font-weight: 600;
    line-height: 1;
  }
  .balances {
    position: absolute;
    top: 25px;
    left: 20px;
  }
}
.benefit-subtitle {
  font-size: 12px;
  font-weight: 600;
}
.amount-title {
  font-size: 9px;
  font-weight: 700;
}
.amount {
  font-size: 11px;
  font-weight: 700;
}
.offset-36 {
  position: relative;
  top: -36px;
}
.balance-chart {
  position: relative;
}
.visit-btn {
  position: absolute;
  bottom: 24px;
  right: 24px;
}
.v-list-item {
  min-height: 20px;
}
.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.balances-card {
  overflow-y: auto;
  overflow-x: hidden;
}
.balances-card::-webkit-scrollbar {
  width: 20px;
  border-width: 5px;
}

.balances-card::-webkit-scrollbar-track-piece {
  background-color: white;
  border-color: white;
  border-width: 2px 7px 2px 7px;
  border-style: solid;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.balances-card::-webkit-scrollbar-thumb {
  border-radius: 7px;
  background-color: var(--accent) !important;
  border-color: white;
  border-style: solid;
  border-width: 1px 4px 1px 4px;
}
.active-icon >>> i {
  color: var(--accent) !important;
}
.v-btn__content .v-icon {
  font-size: 30px !important;
}
.v-tooltip__content {
  max-width: 120px !important;
}
.subtitle {
  font-size: 14px;
}
</style>
